module.exports = __webpack_public_path__ + "static/media/TV.e10198ff.svg";